module.exports = __webpack_public_path__ + "media/images/header__background__topLeft-db26a795c0758c2a8d5b7962db043edd.png";